import { useGateValue } from '@statsig/react-bindings';

const useJapaneseRegionalSite = () => {
  return useGateValue('is_japanese');
};

export default useJapaneseRegionalSite;
